import React, {Component} from 'react';
import config from 'react-global-configuration';
import axios from "axios";
import $ from 'jquery';
import { Collapse, Button, Input, Form, FormGroup, Label } from 'reactstrap';
//import Select from 'react-select';
import 'datatables.net';
import 'datatables.net-responsive';
import "../assets/css/datatables/datatables.min.css";
import {css} from '@emotion/core';
import {BeatLoader} from 'react-spinners';
import NotificationSystem from "react-notification-system";
import {style} from "variables/Variables.jsx";
import '../assets/css/react-confirm-alert/react-confirm-alert.css';
import ReactTooltip from 'react-tooltip';
import {Nav, Navbar, NavItem} from "react-bootstrap";
import {Link} from 'react-router-dom';
import jwt_decode from "jwt-decode";
import Select from 'react-select';
// import '../../assets/css/monthpicker/month-picker.css';
// import Picker from 'react-month-picker'
import imgsrc from '../../src/assets/img/info.png';
//import DayPicker from 'react-day-picker';
//import 'react-day-picker/lib/style.css';
//import Calendar from 'react-calendar'
//import 'react-calendar/dist/Calendar.css';
import DatePicker from 'react-datepicker';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import moment from 'moment';
//import {CSVLink, CSVDownload} from 'react-csv';
//import Table from '../components/json-csv/Table.jsx';
//import Csvdownload from '../components/json-csv/app.jsx';
import CommonNavbar, {navbar} from "./commonNavbar";
import ModalD from "react-awesome-modal";

const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
`;

var todayDate = new Date();
var timestamp  = new Date().getTime();
var yesterday = new Date(Date.now() - 24*60*60*1000);
var tod = moment(yesterday).format('MM/DD/YYYY');
var yest = moment(yesterday).format('MM/DD/YYYY');
var todShow = moment(yesterday).format('D MMM YYYY');
var yestShow = moment(yesterday).format('D MMM YYYY');
var todSend = moment(yesterday).format('YYYY-MM-DD');
var yestSend = moment(yesterday).format('YYYY-MM-DD');
var date_limit = moment(todayDate).format('MM/DD/YYYY');
const dates = {
    startdate :'',
    enddate : ''
}

var d1 = new Date();
const Yesterdaystart =  d1.getFullYear().toString()+"-"+((d1.getMonth()+1).toString().length==2?(d1.getMonth()+1).toString():"0"+(d1.getMonth()+1).toString())+"-"+((d1.getDate()-1).toString().length==2?(d1.getDate()-1).toString():"0"+(d1.getDate()-1).toString())+" "+"00:00:00";
const Yesterdayend =  d1.getFullYear().toString()+"-"+((d1.getMonth()+1).toString().length==2?(d1.getMonth()+1).toString():"0"+(d1.getMonth()+1).toString())+"-"+((d1.getDate()-1).toString().length==2?(d1.getDate()-1).toString():"0"+(d1.getDate()-1).toString())+" "+"23:59:59";

dates.startdate = Yesterdaystart;
dates.enddate = Yesterdayend;

const reportstyle ={ 
backgroundColor:"#f5f5f5",
border: "1px solid #ccc",
margin: "20px 0px",
borderRadius: "5px",
};
const reportinfo = {
    backgroundColor:"linen",
    display:"block",
}
const reporttype = [
    {label:"Sales Report", value:0},
    {label:"API Log Report", value:1}
];

const periodtype = [
    {label:"Yesterday",value:0,color: '#0052CC',},
    {label:"Last 7 days",value:1},
    {label:"Last Month",value:2},
    {label:"Daily",value:3},
    {label:"Monthly",value:4},
    {label:"Custom range",value:5},
];
const formattype =[
    {label:"CSV",value:'1'},
    {label:"XLSX",value:'2'},
];


// const rows = [this.merchantname,this.chain,this.store];

const monthFormat = 'YYYY/MM';
const srch = false;
// const [startDate, setStartDate] = useState(new Date());
// const startDate =new Date();


class NewDataExporter2 extends Component {
    constructor(props){
        super(props);
        this.state = {
            unmapped_files : [],
            unmappedData: {
                id: '',
                user_id: '',
                file_name: '',
                file_path: '',
                timestamp: '',
                version: '',
                cur_version: '',
                status:'',
                user_type: ''
            },
            unmappedModel: false,
            data:[],
            loading:true,
            _notificationSystem: null,
            versions:[],
            tableLists:[],
            newRelationModel: false,
            deleteKeys:[],
            user_id: null,
            map_status: null,
            stored_file_name: null,
            file_name: null,
            userGroup: null,
            id: null,
            campaign_response: [],
            startDate: new Date(),
            name: 'React',
            monthpick :{display : "block"},
            daypick:{display : "block"},
            buttongen:{display : "none"},
            uploadDropdown:true,
            availableReport:false,
            csvData: '',
            filename:"Exporter",
            csvapires:[],
            csvDataRes:[],
            s_date:'',
            e_date:'',
            start_date: Yesterdaystart,
            end_date: Yesterdayend,
            page_number: 1,
            rows_per_page: 10,
            search_query: '',
            brandIDs: [],
            isDisabled: false,
            date_response: 0,
            startDatea: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
            startDatea2: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
            loading: false,
            min_date: moment('2020-10-01 00:00:00').format('YYYY-MM-DD HH:mm:ss'),
            dateTo:tod,
            dateLimit:date_limit,
            dateToShow:todShow,
            todSend:todSend,
            yestSend:yestSend,
            datefrom:yest,
            datefromShow:yestShow,
            party_master_name: null,
            party_master_id: null,
            emiMenus:[],
            selected_report: 1,
            is_void: 1,
            selected_file_type: '1',
            dont_allow: 0,
            party_options: [
                { value: 'Brand', label: 'Brand' },
                { value: 'Merchant', label: 'Merchant' }
            ],
            party_list: [],
            selected_party_type: null,
            selected_party: null,
            selected_party_type2: null,
            selected_party2: [{value: null, label: null}],
            table_data: []
        };
    }
   

    // onChange = date => { this.setState({startDate: date }); };
    handleChange = date => {
        this.setState({
          start_date: date,
          end_date: date
        });
      };

    handleNotificationClick = (position, color, msg) => {
        var level;
        switch (color) {
            case 1:
                level = "success";
                break;
            case 2:
                level = "warning";
                break;
            case 3:
                level = "error";
                break;
            case 4:
                level = "info";
                break;
            default:
                break;
        }
        this.state._notificationSystem.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift" />,
            message: (
                <div>
                    {msg}
                </div>
            ),
            level: level,
            position: position,
            autoDismiss: 5
        });
    };

    componentDidMount() {
        this.getPartyID();
        this.setState({ _notificationSystem: this.refs.notificationSystem });
        var _notificationSystem = this.refs.notificationSystem;
    }

    getTableData(){
        if ($.fn.DataTable.isDataTable('#brandViewTable')) {
            $('#brandViewTable').DataTable().destroy();
        }
        this.setState({
            loading: true
        })
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        console.log("hello");
        axios.post(config.get('API_URL') + '/brandemi/get_api_table_data', {
                brandIDs: this.state.brandIDs,
                start_date: this.state.start_date,
                end_date: this.state.end_date
        },
        {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            console.log(response);
            this.setState({
                table_data: JSON.parse(response.data),
                loading: false
            });
            $('#brandViewTable').DataTable({
                "oLanguage": {
                    "sEmptyTable": "No transaction occurred for given date range"
                }
            });
        });
        return null;
    }



    transactionReportDownload (e){
        var a = moment(this.state.todSend);
        var b = moment(this.state.yestSend);
        var days_beet = a.diff(b, 'days');
        if(days_beet>config.get('REPORT_CSV_DAYS_LIMIT')) {
            alert("Date range too large. Please select a date range of 5 days at a time");
            return false;
        }
        this.setState({
            is_download: false,
            model_visible: true,
            file_url: '',
            rfile: ''
        });
        var postData = {
            mids: this.state.merchantID,
            cids: this.state.chainID,
            sids: this.state.storeID,
            bids: this.state.acqBankIds,
            cityids: this.state.cityIds,
            yestSend: this.state.yestSend,
            todSend: this.state.todSend,
            metric: this.state.metric,
            is_void: this.state.is_void,
            download: true,
            txn_type: 'EMI',
            subventionIDs: this.state.subventionIDs,
            categoryIDs: this.state.categoryIDs,
            brandIDs: this.state.brandIDs,
            modelIDs: this.state.modelIDs,
            emiSchemeIDs: this.state.emiSchemeIDs,
            tenureIDs: this.state.tenureIDs,
            emiIssuerIDs: this.state.emiIssuerIDs
        };

        let xhrBank = $.ajax({
            url:config.get('API_URL')+ "/reports/transaction-reports-download",
            type: "POST",
            data: postData,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", localStorage.usertoken);
            },
            xhrFields: {
                responseType: 'blob'
            },
            success: function (response, status, xhr) {
                let blob = new Blob([response], {
                    type: "octet/stream"
                });
                let fileName = timestamp+'emi_transaction_report.csv.gz';
                let rfile = fileName.replace(/\"/g, "");
                //console.log(fileName)
                //let a = document.createElement('a');
                let url = window.URL.createObjectURL(blob);
                // a.href = url;
                // a.download = rfile;
                // a.click();
                // window.URL.revokeObjectURL(url);
                this.setState({
                    is_download: true,
                    file_url: url,
                    rfile: rfile
                })
            }.bind(this)
        });
        this.setState({
            xhrBank: xhrBank
        })

    }

    downloadFile(e){ //alert(this.state.file_url);
        let a = document.createElement('a');
        a.href = this.state.file_url;
        a.download = this.state.rfile;
        a.click();
        window.URL.revokeObjectURL(this.state.file_url);
    }


    getPartyID(){
        if ($.fn.DataTable.isDataTable('#party_showTable')) {
            $('#party_showTable').DataTable().destroy();
        }
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        
        
        axios.get(config.get('API_URL') + '/brandemi/get_party_id',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                user_id: decoded._id,
            }
        }).then(response => {
            //console.log(response.data);
            if(response.data.length == 0 && (decoded.userGroup == 1 || decoded.userGroup == '1')){
                this.setState({
                    party_master_id: 3,
                    loading: false,
                    user_id: decoded._id
                });
            }
            else{
                let selected_party2 = [];
                response.data.map((values, index) => {
                    let to_add = '';
                    this.setState({
                        party_master_id: values.party_id
                    }, () => {
                        this.getPartyName();
                    })
                });
                this.setState({
                    selected_party2: selected_party2,
                    loading: false,
                    party_id_mapper: response.data,
                    user_id: decoded._id
                })
                $('#party_showTable').DataTable();
            }
        });
    }

    getPartyName() {
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.get(config.get('API_URL') + '/brandemi/get_party_name',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                party_master_id: this.state.party_master_id
            }
        }).then(response => {
            //console.log(response.data);
            response.data.map((values, index) => {
                //console.log(values.party_id);
                this.setState({
                    party_master_name: values.party_name,
                    brandIDs: [values.party_name]
                })
            })
            this.getTableData();
        });
    }

    exportCSV () {
    //    alert(dates.startdate);
    //    alert(dates.enddate);
    this.setState({
        csvapires: null
    });
        axios.get(config.get('API_URL') + '/brandemi/brand_api_logs',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                party_master_id: "3",
                userGroup:"7",
                s_date:dates.startdate,
                e_date:dates.enddate
                // s_date : "2020-03-23 05:30:00",
                // e_date : "2020-03-27 00:00:59"
            }
        }).then(response => {
            //console.log(response.data);
            if(response.data.length==0)
            {
                this.setState({availableReport:false});
            }
            else{  
                this.setState({availableReport:true});
            this.setState({
                csvapires: response.data
            });
               //alert(this.state.csvDataRes);
               }
        });

    };

// export CSV code start here

handleEvent(event, picker, e) {
    this.setState({
        todSend: moment(picker.endDate).format('YYYY-MM-DD HH:mm:ss'),
        yestSend: moment(picker.startDate).format('YYYY-MM-DD HH:mm:ss'),
        datefromShow: moment(picker.startDate).format('D MMM YYYY'),
        dateToShow: moment(picker.endDate).format('D MMM YYYY')
    });
    console.log(event.type);
    if(event.type=='apply' || event.type=='hide'){
        let start_date = moment(picker.startDate);
        let end_date = moment(picker.endDate);
        //console.log(end_date-start_date);
        const diff = end_date.diff(start_date);
        const diffDuration = moment.duration(diff);
        // console.log("Days:", diffDuration.days());
        // console.log("Months: ", diffDuration.months());
        if(diffDuration.months() >= 1){
            this.handleNotificationClick("tr", 3, "Date range cannot be greater than 31 days");
            this.setState({
                dont_allow: 1
            })
        }
        else{
            this.setState({
                start_date: moment(picker.startDate).format('YYYY-MM-DD HH:mm:ss'),
                end_date: moment(picker.endDate).format('YYYY-MM-DD HH:mm:ss'),
                dont_allow: 0
            },() =>{
                this.getTableData();
            })
        }
    }
}

 convertToCSV = (objArray) =>{
    var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    var str = '';

    for (var i = 0; i < array.length; i++) {
        var line = '';
        for (var index in array[i]) {
            if (line != '') line += ','

            line += array[i][index];
        }

        str += line + '\r\n';
    }

    return str;
}

 exportCSVFile = (headers, items, fileTitle) =>{
    if (headers) {
        items.unshift(headers);
    }

    // Convert Object to JSON
    var jsonObject = JSON.stringify(items);

    var csv = this.convertToCSV(jsonObject);

    var exportedFilenmae = fileTitle + '.csv' || 'export.csv';

    var blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    if (navigator.msSaveBlob) { // IE 10+
        navigator.msSaveBlob(blob, exportedFilenmae);
    } else {
        var link = document.createElement("a");
        if (link.download !== undefined) { // feature detection
            // Browsers that support HTML5 download attribute
            var url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", exportedFilenmae);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }
}

 downloadReport = () =>{
        this.setState({
            loading: true
        })
        // const data = new FormData();
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);

        // let date1 = moment(this.state.startDate).format('YYYY-MM-DD');
        // let date2 = moment(this.state.endDate).format('YYYY-MM-DD');
        // data.append('start_date', this.state.start_date);
        // data.append('end_date', this.state.end_date);
        // data.append('brandIDs', JSON.stringify(this.state.brandIDs));
        var postData = {
            start_date: this.state.start_date,
            end_date: this.state.end_date,
            brandIDs: this.state.brandIDs,
            selected_report: this.state.selected_report,
            is_void: this.state.is_void,
            file_type: this.state.selected_file_type,
            party_name: this.state.party_master_name
        }
        let xhrBank = $.ajax({
            url:config.get('API_URL')+ "/brandemi/create_report",
            type: "POST",
            data: postData,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", localStorage.usertoken);
            },
            xhrFields: {
                responseType: 'blob'
            },
            success: function (response, status, xhr) {
                //console.log(response);
                let blob = new Blob([response], {
                    type: "application/csv"
                });
                let fileName= '';
                let fileTypea='.csv'
                if(this.state.selected_file_type == '1'){
                    fileTypea='.csv'
                }
                else{
                    fileTypea='.xlsx'
                }
                if(this.state.selected_report == 0 || this.state.selected_report == '0'){
                    fileName = 'sales-report-' + moment(this.state.start_date).format('DD-MM-YYYY') + '-to-' + moment(this.state.end_date).format('DD-MM-YYYY') + fileTypea;
                }
                else{
                    fileName = 'api-log-report-' + moment(this.state.start_date).format('DD-MM-YYYY') + '-to-' + moment(this.state.end_date).format('DD-MM-YYYY') + fileTypea;
                }
                //alert(fileName);
                let rfile = fileName.replace(/\"/g, "");
                // console.log(fileName);
                let a = document.createElement('a');
                let url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = rfile;
                a.click();
                //console.log(a);
                window.URL.revokeObjectURL(url);
                this.setState({
                    is_download: true,
                    loading: false
                })
            }.bind(this)
        });
        this.setState({
            xhrBank: xhrBank
        })

    }

    setDescription = (optionSelected) => {
        this.setState({ selectedDescription: optionSelected });
        //console.log(this.state.selectedDescription)
    };
    updateSKU = (optionSelected) => {
        //this.setState({ selectedSKU: optionSelected.value })
    };
    updatePrice = (optionSelected) => {
        //this.setState({ selectedPrice: optionSelected.value })
    };
    
    toggleunmappedModel() {
        this.setState({
            unmappedModel: !this.state.unmappedModel
        })
    }
    campaignDropdown = () => {
        this.props.history.push('/admin/promotions')
    }
    
    getPartyList = () => {
        const token = localStorage.usertoken;
        axios.post(config.get('API_URL')+'/brandemi/get_party_list', {
                party_type1: this.state.selected_party_type
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            })
            .then(response => { //console.log(response);
            let party_list = [];
            this.setState({
                party_list: [],
                selected_party: null
            });
            response.data.map((values, index) => {
                party_list.push({value: values.id, label: values.party_name})
            });
            this.setState({
                party_list: party_list,
                loading: false
            })
        });
    }

    mapData(id, map_status, stored_file_name, user_type, user_id, file_name){
        this.setState({
            id: id,
            map_status: map_status,
            stored_file_name: stored_file_name,
            userGroup: user_type,
            user_id: user_id,
            file_name: file_name
        });
        this.openSectionToMap(true);
    }

    goBack = () => {
        this.props.history.push('/admin/brand-emi')
    }

    openSectionToMap = (status) => {
        //console.log(this.state.userGroup);
        this.setState({
            mapField: status
        })
    };

    updatePartyType = (valuer) => {
        if (valuer.value == 'Merchant'){
            this.handleNotificationClick("tr", 3, "Merchant reports are currently unavailable.");
            // this.setState({
            //     selected_party_type: valuer.value,
            //     selected_party_type2: [{value: valuer.value, label: valuer.label}],
            //     uploadDropdown: false,
            //     upload_user_type: 2,
            //     loading: true,
            //     selected_party: null,
            //     selected_party2: null,
            //     party_list: [],
            //     party_master_id: 5,
            // }, () => {
            //     this.getPartyList();
            //     this.getBrandUploadedData();
            // });
        }
        else if( valuer.value == 'Brand'){
            this.setState({
                selected_party_type: valuer.value,
                selected_party_type2: [{value: valuer.value, label: valuer.label}],
                uploadDropdown: false,
                upload_user_type: 7,
                loading: true,
                selected_party: null,
                selected_party2: [{value: null, label: null}],
                party_master_id: 5,
                party_list: []
            }, () => {
                this.getPartyList();
            });
        }
    };

    updatePartyValue = (valuer) => {
        this.setState({
            selected_party: valuer.value,
            selected_party2: [{value: valuer.value, label: valuer.label}],
            party_master_id: valuer.value,
            loading: false,
            uploadDropdown: false
        }, () =>{
            this.getPartyName();
        });
        
    };

    updateMapVisiblity = (value) => {
        //console.log(JSON.stringify(value));
        this.setState({
            mapField: value
        })
    };

    showperiod =  (prinput) => {
        if(prinput.value==0 || prinput.value==1)
        {this.setState({isDisabled:false})}
        this.setState({
            selected_report: prinput.value
        })
    }
    
    fileTypeChange = (valuer) =>{
        if(valuer.value=='1' || valuer.value=='2')
        {this.setState({isDisabled:false})}
        this.setState({
            selected_file_type: valuer.value
        })
    }

    handleFromChange = date => {
        this.setState({
            start_date: moment(date).format('YYYY-MM-DD HH:mm:ss'),
            startDatea2: moment(date).format('YYYY-MM-DD HH:mm:ss'),
            end_date: moment(date).format('YYYY-MM-DD HH:mm:ss')
        });
    };

    handleFromChangeMonth = date => {
        var get_month = date.getMonth();
        var get_year = date.getFullYear();
        var get_month_incr = get_month + 1
        var get_montha = '' + get_year + '-' + get_month_incr + '-01'
        if ((date.getMonth() == todayDate.getMonth()) && (date.getFullYear() == todayDate.getFullYear())){
            this.setState({
                start_date: moment(get_montha).format('YYYY-MM-DD HH:mm:ss'),
                startDatea2: moment(get_montha).format('YYYY-MM-DD HH:mm:ss'),
                end_date: moment(todayDate).format('YYYY-MM-DD HH:mm:ss')
            });
        }
        else{
            var datea = new Date(get_year, get_month + 1, 0);
            this.setState({
                start_date: moment(get_montha).format('YYYY-MM-DD HH:mm:ss'),
                startDatea2: moment(get_montha).format('YYYY-MM-DD HH:mm:ss'),
                end_date: moment(datea).format('YYYY-MM-DD HH:mm:ss')
            });
        }
    };

    dtperiodChange = (dtinput) => {
        let res = dtinput.value;
        var d = new Date();
        //console.log(res);
        this.setState({
            date_response: res
        })
        this.setState({ buttongen: {display:"block"}});
        if(res==0)
        {  
             //2020-03-31 13:35:00
            // const today =  d.getFullYear().toString()+"-"+((d.getMonth()+1).toString().length==2?(d.getMonth()+1).toString():"0"+(d.getMonth()+1).toString())+"-"+(d.getDate().toString().length==2?d.getDate().toString():"0"+d.getDate().toString())+" "+(d.getHours().toString().length==2?d.getHours().toString():"0"+d.getHours().toString())+":"+((parseInt(d.getMinutes()/5)*5).toString().length==2?(parseInt(d.getMinutes()/5)*5).toString():"0"+(parseInt(d.getMinutes()/5)*5).toString())+":00";
             const Yesterdaystart =  d.getFullYear().toString()+"-"+((d.getMonth()+1).toString().length==2?(d.getMonth()+1).toString():"0"+(d.getMonth()+1).toString())+"-"+((d.getDate()-1).toString().length==2?(d.getDate()-1).toString():"0"+(d.getDate()-1).toString())+" "+"00:00:00";
             const Yesterdayend =  d.getFullYear().toString()+"-"+((d.getMonth()+1).toString().length==2?(d.getMonth()+1).toString():"0"+(d.getMonth()+1).toString())+"-"+((d.getDate()-1).toString().length==2?(d.getDate()-1).toString():"0"+(d.getDate()-1).toString())+" "+"23:59:59";

             dates.startdate = Yesterdaystart;
             dates.enddate = Yesterdayend;
             this.setState({
                 start_date: Yesterdaystart,
                 end_date: Yesterdayend
             }, () =>{
                 this.getTableData();
             }
             )
         
        }
        else if(res==1)
        {
            d.setDate(d.getDate() - 7);
            const LastSevenStart =  d.getFullYear().toString()+"-"+((d.getMonth()+1).toString().length==2?(d.getMonth()+1).toString():"0"+(d.getMonth()+1).toString())+"-"+(d.getDate().toString().length==2?d.getDate().toString():"0"+d.getDate().toString())+" "+"00:00:00";
            d.setDate(d.getDate() + 6);
            const LastSevenEnd =  d.getFullYear().toString()+"-"+((d.getMonth()+1).toString().length==2?(d.getMonth()+1).toString():"0"+(d.getMonth()+1).toString())+"-"+(d.getDate().toString().length==2?d.getDate().toString():"0"+d.getDate().toString())+" "+"23:59:59";

            dates.startdate = LastSevenStart;
            dates.enddate = LastSevenEnd;
            //this.exportCSV();
            this.setState({
                start_date: LastSevenStart,
                end_date: LastSevenEnd
            }, () =>{
                this.getTableData();
            })
           
        }
        else if(res==2)
        {
            const LastMonthStart =  d.getFullYear().toString()+"-"+((d.getMonth()).toString().length==2?(d.getMonth()).toString():"0"+(d.getMonth()).toString())+"-"+(d.getDate().toString().length==2?d.getDate().toString():"0"+d.getDate().toString())+" "+"00:00:00";
            const LastMonthEnd =  d.getFullYear().toString()+"-"+((d.getMonth()+1).toString().length==2?(d.getMonth()+1).toString():"0"+(d.getMonth()+1).toString())+"-"+((d.getDate()-1).toString().length==2?(d.getDate()-1).toString():"0"+d.getDate().toString())+" "+"23:59:59";

            dates.startdate = LastMonthStart;
            dates.enddate = LastMonthEnd;
            this.setState({
                start_date: LastMonthStart,
                end_date: LastMonthEnd
            }, () =>{
                this.getTableData();
            })
            //this.exportCSV();
        }
       else if(res==3)
        {
            this.setState({
                start_date: this.state.startDatea,
                startDatea2: this.state.startDatea,
                end_date: this.state.startDatea,
            }, () =>{
                this.getTableData();
            });
            // this.setState({
            //     start_date: LastMonthStart,
            //     end_date: LastMonthEnd
            // })
        }
        else if(res==4)
        {    
            var this_date = todayDate;
            var get_month = this_date.getMonth();
            var get_year = this_date.getFullYear();
            var get_month_incr = get_month + 1
            var get_montha = '' + get_year + '-' + get_month_incr + '-01'
            this.setState({
                start_date: moment(get_montha).format('YYYY-MM-DD HH:mm:ss'),
                startDatea2: this.state.startDatea,
                end_date: moment(todayDate).format('YYYY-MM-DD HH:mm:ss')
            }, () =>{
                this.getTableData();
            });
        }
        else if(res==5){
            this.setState({
                start_date: this.state.startDatea,
                end_date: this.state.startDatea
            }, () =>{
                this.getTableData();
            });
        }
    }
    
    render() {
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        let party_render = this.state.party_options;
        let party_render_list = this.state.party_list;
        let party_shower = () => {
            if(decoded.userGroup == 1 || decoded.userGroup == '1'){
                return(
                    <div className="row top-margin-10">
                        <div className="col-md-3">
                            <p><strong>Select party type</strong></p> 
                            <Select name={"party_type"}
                                value={this.state.selected_party_type2}
                                onChange={this.updatePartyType.bind(this)}
                                options={party_render}
                                placeholder="Select party type"
                                // isClearable={true}
                            />
                        </div>  
                        <div className="col-md-3">
                            <p><strong>Select party</strong></p>
                            <Select name={"party_name"}
                                value={this.state.selected_party2}
                                onChange={this.updatePartyValue.bind(this)}
                                options={party_render_list}
                                placeholder="Select party"
                                // isClearable={true}
                            />
                        </div> 
                    </div>
                )
            }
            else{
                return(
                    <div></div>
                )
            }
        }
        console.log(this.state.start_date);
        console.log(this.state.end_date);
        console.log(this.state.date_response);
        
        let dater = () => {
            if (this.state.date_response == 3 || this.state.date_response == '3' ){
                return(
                    <div className="col-md-3 dash-header">
                        <p> <strong> Select Day </strong></p>
                        <DatePicker
                            dateFormat="dd-MM-yyyy"
                            selected={Date.parse(this.state.startDatea2)}
                            onChange={this.handleFromChange}
                            minDate={this.state.min_date}
                            maxDate={new Date()}
                        />
                    </div>
                )
            }
            else{
                return(
                    <div></div>
                )
            }
        }

        let monther = () => {
            if(this.state.date_response == 4 || this.state.date_response == '4'){
                return(
                    <div className="col-md-3 dash-header">
                        <p> <strong> Select Month </strong></p>
                        <DatePicker
                            dateFormat="MM-yyyy"
                            selected={Date.parse(this.state.startDatea2)}
                            onChange={this.handleFromChangeMonth}
                            showMonthYearPicker
                            minDate={this.state.min_date}
                            maxDate={new Date()}
                        />
                    </div>
                )
            }
            else{
                return(
                    <div></div>
                )
            }
        }
        let ranger = () => {
            if(this.state.date_response == 5 || this.state.date_response == '5'){
                return(
                    <div className="col-md-3 dash-header">
                        <p> <strong> Select Date Range </strong></p>
                        <DateRangePicker startDate={this.state.datefrom} endDate={this.state.dateTo}
                            onEvent={this.handleEvent.bind(this)}  maxDate = {this.state.dateLimit}>
                            <input type="text" name="dateRange" className="form-control dateRangeInput"
                            value={this.state.datefromShow + ' - ' + this.state.dateToShow}/>
                        </DateRangePicker>
                    </div>
                )
            }
        }

        let contenter = () => {
            if(this.state.selected_report == '0' || this.state.selected_report == 0){
                return(
                    <div className="col-md-12  top-pad-5">
                        <small>This report provides details of all EMI transactions that were initiated in the selected time range.</small>
                    </div>
                )
            }
            else{
                return(
                    <div className="col-md-12  top-pad-5">
                        <small>This report provides details of all APIs that were called during the transaction in the selected time range.</small>
                    </div>
                )
            }
        }

        let buttondisabler = '';

        if (this.state.date_response == null || (this.state.dont_allow == 1 && this.state.date_response == 5) || ((decoded.userGroup == 1 || decoded.userGroup == '1' ) && this.state.selected_party == null)){
            buttondisabler = true;
        }
        else{
            buttondisabler = false;
        }
        
        let brand_file_data = null;
        console.log(this.state.table_data.length);
        console.log(this.state.table_data);
        if (this.state.table_data.length != 0){
            brand_file_data = this.state.table_data.map((value, index) =>{
                return (
                    <tr key={index + 1}>
                    <td>{value.Merchant}</td>
                    <td>{value.Chain}</td>
                    <td>{value.Store}</td>
                    <td>{value.Merchant_Metadata}</td>
                    <td>{value.Promotion_Name}</td>
                    <td>{value.Scheme_Name}</td>
                    <td>{value.Scheme_Code}</td>
                    <td>{value.Product_Name}</td>
                    <td>{value.Product_ID}</td>
                    <td>{value.Transaction_ID}</td>
                    <td>{value.Category}</td>
                    <td>{value.Brand}</td>
                    <td>{value.Model}</td>
                    <td>{value.IMEI_Serial_Number}</td>
                    <td>{value.API_Status}</td>
                    <td>{value.Verification_TAT}</td>
                    <td>{value.Failure_Reason}</td>
                    <td>{value.Transaction_Status}</td>
                    <td>{value.Timestamp}</td>
                    <td>{value.Transaction_Type}</td>
                </tr>
                )
            });
        }

        return(
        <div className="content longcontent">
            <CommonNavbar/>
                <NotificationSystem ref="notificationSystem" style={style} />
                <ReactTooltip />
                <div className="col-md-12 top-pad-5">
                    <div className="card ">
                        <div className="header">
                            <h4 className="title pull-left">API Log Report</h4>
                        </div>      {/* <button onClick={this.campaignDropdown} className="btn btn-primary btn-capitalize pull-right">Create New</button> */}
                        <div className="content">
                        <div className='sweet-loading'>
                                <BeatLoader
                                    css={override}
                                    sizeUnit={"px"}
                                    size={20}
                                    color={'#123abc'}
                                    loading={this.state.loading}
                                />
                            </div>
                                {/* {party_shower()}
                           <div className="row"> 
                            <div className="col-md-3 dash-header">
                                 <p> <strong> Select report type </strong></p> 
                                <Select defaultValue={{ label: "Sales Report", value: 0 }} options={reporttype}  onChange={this.showperiod.bind(this)}/>
                            </div>
                            {contenter()}
                         </div> */}

                         <div className="row"> 
                            <div className="col-md-3 dash-header">
                                 <p> <strong> Select period </strong></p> 
                                <Select
                                    defaultValue={{ label: "Yesterday", value: 0 }}
                                    isSearchable ={srch}
                                    isDisabled ={this.state.isDisabled}
                                    onChange={this.dtperiodChange.bind(this)}
                                    name="date"
                                    options={periodtype}
                                />
                                
                            </div> 
                            {dater()}
                            {monther()}
                            {ranger()}
                         
                         </div>

                         <div className="row"> 
                            <div className="col-md-3 dash-header">
                                 <p> <strong> Select Format </strong></p> 
                                <Select options={formattype} defaultValue={{ label: "CSV", value: '1' }} onChange={this.fileTypeChange.bind(this)} isDisabled ={this.state.isDisabled}/>
                            </div>
                         </div>
                     
                         <div className="row"> 
                            <div className="col-md-3 dash-header">
                                <button  className="btn btn-primary btn-capitalize pull-left" disabled={buttondisabler} onClick={this.downloadReport} >Generate Report</button>
                            </div>
                            
                        </div>
                            
                            <hr/>
                            <div className="row">
                                <div className="container-fluid">
                                    <div className="content-tdetails-table table-full-width table-responsive marginTop0">    
                                        <table className="table table-striped table-hover" id="brandViewTable">
                                            <thead>
                                                <tr>
                                                    <th width="100px">Merchant</th>
                                                    <th width="100px">Chain</th>
                                                    <th width="100px">Store</th>
                                                    <th>Merchant Metadata</th>
                                                    <th>Promotion Name</th>
                                                    <th>Scheme Name</th>
                                                    <th>Scheme Code</th>
                                                    <th>Product Name</th>
                                                    <th>Product ID</th>
                                                    <th width="150px">Transaction ID</th>
                                                    <th>Category</th>
                                                    <th>Brand</th>
                                                    <th>Model</th>
                                                    <th>IMEI/Serial Number</th>
                                                    <th>API Status</th>
                                                    <th>Verification TAT</th>
                                                    <th>Failure Reason</th>
                                                    <th>Transaction Status</th>
                                                    <th>Timestamp</th>
                                                    <th>Transaction Type</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {brand_file_data}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
      );
    }
}


export default NewDataExporter2;